import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Divider } from "@gemini/ui";
import { UnitInfo } from "../UnitInfo";
import { UnitButtons } from "../UnitButtons";
export const testId = "cdp-sections-units-unit";
export const Unit = ({ unit, isLast }) => {
    return (_jsxs(Box, { as: "li", testId: testId, children: [_jsxs(Box, { display: "flex", flexDirection: {
                    "breakpoint.base": "column",
                    "breakpoint.lg": "row",
                }, paddingVertical: {
                    "breakpoint.base": "spacing.16",
                    "breakpoint.lg": 0,
                }, children: [_jsx(UnitInfo, { unit: unit }), _jsx(UnitButtons, { ...unit })] }), !isLast && (_jsx(Divider, { marginVertical: {
                    "breakpoint.base": "spacing.8",
                    "breakpoint.lg": "spacing.16",
                } }))] }));
};
